import queryClient from '@api/queryClient'
import type { OrderExport, OrderFilters } from '@models/order'
import ordersApi from './actions'
import { ordersKeys } from './constants'

const EXPORT_STALE_TIME = 3 * 60 * 1000

const useOrdersExport = () => {
  const fetchOrdersExport = (
    filters: Omit<OrderFilters, 'take' | 'skip'>,
  ): Promise<OrderExport[]> => {
    return queryClient.fetchQuery({
      queryKey: ordersKeys.orderExport(filters),
      queryFn: () => ordersApi.getOrdersExport(filters),
      staleTime: EXPORT_STALE_TIME,
    })
  }

  return { fetchOrdersExport }
}

export default useOrdersExport
